module.exports = __webpack_public_path__ + "static/media/wrinkles_periocular.061d408e.svg";